<div>
  <div class="select-demo-source d-flex align-items-center no-channel-selection"
       [ngClass]="{'mobile-source': isMobile, 'no-channel-selection': selectedSource === 0}"
       *ngIf="showDemographicSourceSelection">
    <span class="demo-source-selection-label">{{'INFLUENCER.labels.channel_selector' | translate}}</span>
    <demographic-source-selection [dataSources]="demographicSources"
                                  [(model)]="selectedSource"
                                  (selectDemographicSourceEvent)="onSelectDemographicSource($event)">
    </demographic-source-selection>
  </div>
  <div class="demographic-loader">
    <achoo-placeholder [placeholderId]="'demographicPlaceholder'" [normalPlaceholder]="true" [isFullscreenLoader]="false">
    </achoo-placeholder>
  </div>
  <div *ngIf="showDeepSocialDemographicData">
    <influencer-demographics *ngIf="!isRedesignDemographic"
                             [deepSocialData]="deepSocialData"
                             [demoInfluencerId]="demoInfluencerId"
                             [pieCenter]="pieCenter"
                             [pieHeight]="pieHeight"
                             [pieInnerSize]="pieInnerSize"
                             [pieLegend]="pieLegend"
                             [pieSize]="pieSize"
                             [pieTitleStyling]="pieTitleStyling">
    </influencer-demographics>
    <new-influencer-demographic *ngIf="isRedesignDemographic"
                              [demographicData]="deepSocialData"
                              [influencerId]="demoInfluencerId"
                              [pieCenter]="pieCenter"
                              [pieHeight]="pieHeight"
                              [pieInnerSize]="pieInnerSize"
                              [pieLegend]="pieLegend"
                              [pieSize]="pieSize"
                              [isDeepSocialData]="true">
    </new-influencer-demographic>
  </div>
  <div *ngIf="showHypeAuditorDemographicData">
    <demographic-hype-auditor *ngIf="!isRedesignDemographic"
                              [demographicData]="hypeAuditorData"
                              [influencerId]="demoInfluencerId"
                              [pieCenter]="pieCenter"
                              [pieHeight]="pieHeight"
                              [pieInnerSize]="pieInnerSize"
                              [pieLegend]="pieLegend"
                              [pieSize]="pieSize">
    </demographic-hype-auditor>
    <new-influencer-demographic *ngIf="isRedesignDemographic"
                              [demographicData]="hypeAuditorData"
                              [influencerId]="demoInfluencerId"
                              [pieCenter]="pieCenter"
                              [pieHeight]="pieHeight"
                              [pieInnerSize]="pieInnerSize"
                              [pieLegend]="pieLegend"
                              [pieSize]="pieSize"
                              [printMode]="printMode">
    </new-influencer-demographic>
  </div>
  <div *ngIf="showFallback">
    <demographic-fallback [showNotificationPopup]="showNotificationInFallback" [messageTitle]="fallbackMsgTitle" [messageContent]="fallbackMsgContent"></demographic-fallback>
  </div>
</div>

<achoo-popup #UnSupportNetworkNotification
             [isNotification]="true"
             modelTitle="{{'common.error' | translate}}"
             (acceptCallback)="closeNotification()"
             (cancelCallback)="closeNotification()">
  <span>{{'INFLUENCER.not_supported_network' | translate}}</span>
</achoo-popup>

<achoo-popup #UnsupportedPlatformNotification
             [isNotification]="true"
             modelTitle="{{'common.error' | translate}}"
             (acceptCallback)="closeNotification()"
             (cancelCallback)="closeNotification()">
  <span>{{'INFLUENCER.demographic.not_supported_platform_msg' | translate}}</span>
</achoo-popup>

<achoo-popup #DataOutdatedNotification
             [isNotification]="true"
             modelTitle="{{'common.alert' | translate}}"
             (acceptCallback)="closeNotification()"
             (cancelCallback)="closeNotification()">
  <div class="d-flex flex-column">
    <span class="outdated-msg">{{'demographic_notification.outdated_1' | translate}}</span>
    <div class="d-flex flex-row">
      <a class="outdated-link" (click)="openHypeAuditor()">{{'demographic_notification.outdated_click_here' | translate}}</a>
      <span class="outdated-msg">{{'demographic_notification.outdated_2' | translate}}</span>
    </div>
  </div>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/main/influencer/demographic/demographic.component.html